export default "__VITE_ASSET__CTxGGSXy__"